import axios from "axios";

// let base = ''
//登录
export const requestLogin = params => {
  return axios.post("/api/login", params).then(res => res);
};
//账户信息
export const getQuota = params => {
  return axios.get("/api/me/quota", { params: params });
};
//获取用户个人信息
export const getUserInfo = params => {
  return axios.get("/api/me/info", { params: params });
};
// 记录用户信息
export const addUserLogByType = params => {
  return axios.get("/api/addUserLogByType", { params: params });
};

export const checkUserApp = params => {
  return axios.get("/api/me/checkApp", { params: params });
};
//检查用户是否存在
export const checkUserName = params => {
  return axios.post("/api/check_user_name", params).then(res => res);
};
export const getIndustryCountry = params => {
  return axios.get("/api/me/industry-country", { params: params });
};
//修改密码
export const updatePsw = params => {
  return axios.post("/api/me/pwd", params).then(res => res.data);
};
//上传头像
export const avatarUpload = "/api/me/upload";
//上传名片
export const cardUpload = "/api/me/upload-card";
//更新用户个人信息
export const updateUserInfo = params => {
  return axios.post("/api/me/modifyInfo", params).then(res => res);
};
//上传EXCEL文档
export const uploadExcelUrl = "/api/import/up-excel";
//忘记密码
export const forgotPassword = params => {
  return axios.post("/api/forgot", params).then(res => res);
};
//修改密码
export const modifyPassword = params => {
  return axios.post("/api/modify", params).then(res => res);
};
//上传图片
export const marketingUpload = "/api/marketing/upload";
//支付
export const payAmount = params => {
  return axios.post("/api/pay/pay", params).then(res => res);
};
//检查支付是否完成
export const checkPay = params => {
  return axios.post("/api/pay/check-pay", params).then(res => res);
};

export const sendRegSendCode = params => {
  return axios.post("/api/reg_send_code", params).then(res => res);
};
export const regUser = params => {
  return axios.post("/api/reg_user", params).then(res => res);
};

//获取国家列表
export const getStaticInfo = params => {
  return axios.get("/api/getStaticInfo", { params: params }).then(res => res);
};
//接口获取公司列表
export const searchCompanyList = params => {
  return axios.post("/api/search-company-list", params).then(res => res);
};
//接口获取游客公司列
export const searchVCompanyList = params => {
  return axios
    .post("/api/visitor/search-company-list", params)
    .then(res => res);
};
//获取联系人列表
export const searchContactList = params => {
  return axios.post("/api/search-contact-list", params).then(res => res);
};
//获取访客联系人列表
export const searchVContactList = params => {
  return axios
    .post("/api/visitor/search-contact-list", params)
    .then(res => res);
};
//公司详情
export const searchCompanyDetail = params => {
  return axios.post("/api/search-company-detail", params).then(res => res);
};
export const searchVCompanyDetail = params => {
  return axios
    .post("/api/visitor/search-company-detail", params)
    .then(res => res);
};
//查看过的记录
export const getAlreadyLookData = params => {
  return axios.post("/api/get-already-look-data", params).then(res => res);
};
//查看联系人
export const lookUpSomeone = params => {
  return axios.post("/api/look-up-someone", params).then(res => res);
};
//公司新闻
export const getCompanyNews = params => {
  return axios
    .get("/api/recommend/company-news", { params: params })
    .then(res => res);
};
//获取社交信息
export const getSocial = params => {
  return axios
    .get("/api/activity/social-list", { params: params })
    .then(res => res);
};
//获取交易详情
export const getTransactionRecord = params => {
  return axios
    .get("/api/recommend/trans-stat", { params: params })
    .then(res => res);
};

//海关数据接口
export const getPurchaseProductAnalysis = params => {
  return axios
    .get("/api/recommend/purchase-product", { params: params })
    .then(res => res);
};
export const getPurchaseRecord = params => {
  return axios
    .get("/api/recommend/purchase-record", { params: params })
    .then(res => res);
};
export const getProviderDetail = params => {
  return axios
    .get("/api/recommend/provider-detail", { params: params })
    .then(res => res);
};
//获取联系人筛选条件
export const getContactCondition = params => {
  return axios
    .get("/api/company/contact-condition", { params: params })
    .then(res => res);
};
export const getThinkingKey = params => {
  return axios
    .get("/api/thinking-keyword", { params: params })
    .then(res => res);
};

//导出数据到Email
export const exportEmailUrl = params => {
  return axios.post("/api/search/export-email", params).then(res => res);
};
//导出数据
export const exportExcelUrl = "/api/search/export";

export const checkVfree = params => {
  return axios
    .get("/api/visitor/check-Vfree", { params: params })
    .then(res => res);
};
export const checkfree = params => {
  return axios.get("/api/check-free", { params: params }).then(res => res);
};
export const checkCttfree = params => {
  return axios.get("/api/check-ctt-free", { params: params }).then(res => res);
};
//获取套餐信息
export const getMeal = params => {
  return axios.get("/api/get-meal", { params: params }).then(res => res);
};
//升级套餐
export const upgradeMeal = params => {
  return axios.post("/api/upgrade-plan", params).then(res => res);
};
//升级套餐
export const changeOverAllow = params => {
  return axios.post("/api/change-overallow", params).then(res => res);
};
//检查套餐是否可升级
export const checkBalanceMeal = params => {
  return axios.post("/api/check-condition", params).then(res => res);
};

//获取验证信息
export const checkSlide = params => {
  return axios.post("/api/getSlideCode", params).then(res => res);
};

//获取搜索热词
export const getKeyword = params => {
  return axios.get("/api/getKeyword", { params: params }).then(res => res);
};
//获取热词二级关联
export const secondThinking = params => {
  return axios.get("/api/secondThinking", { params: params }).then(res => res);
};

//发送验证短信
export const sendMessage = params => {
  return axios.post("/api/sendMessage", params).then(res => res);
};
//动态登录接口
export const dynamicLogin = params => {
  return axios.post("/api/dynamicLogin", params).then(res => res);
};
//获取消息
export const getMessage = params => {
  return axios.get("/api/message", { params: params }).then(res => res);
};
//获取消息详情
export const getMessageInfo = params => {
  return axios.post("/api/message-info", params).then(res => res);
};

//获取会员用户额度花费
export const memberAccount = params => {
  return axios.get("/api/memberAccount", { params: params }).then(res => res);
};
//提交上下游公司表单
export const formCompanyUl = params => {
  return axios.post("/api/formCompanyUl", params).then(res => res);
};
//获取提交的上下游公司列表
export const formCompanyList = params => {
  return axios.get("/api/formCompanyList", { params: params }).then(res => res);
};
//获取一条上下游公司
export const getOneCompanyUl = params => {
  return axios.post("/api/getOneCompanyUl", params).then(res => res);
};
//提交邮箱分享
export const emailShare = params => {
  return axios.post("/api/emailShare", { params: params }).then(res => res);
};
//邮箱分享展示
export const emailShareList = params => {
  return axios.get("/api/emailShareList", { params: params }).then(res => res);
};
//获取分享链接
export const shareUrl = params => {
  return axios.get("/api/shareUrl", params).then(res => res);
};
//企业认证提交
export const certification = params => {
  return axios.post("/api/certification", params).then(res => res);
};
//企业认证获取
export const getCertification = params => {
  return axios.get("/api/getCertificationCompany", params).then(res => res);
};
//企业认证图片类提交
export const companyCardUpload = "/api/company/upload-card";
//企业认证视频提交
export const companyVideoUpload = "/api/company/upload-video";
//消费记录
export const consumptionRecode = params => {
  return axios.post("/api/consumptionRecode", params).then(res => res);
};
//绑定手机、邮箱
export const bindContact = params => {
  return axios.post("/api/bind-contact", params).then(res => res);
};

//添加到收藏
export const addToCollectApi = params => {
  return axios.post("/api/add-to-collect", params).then(res => res);
};
//意见反馈提交
export const FeedbackSubmit = params => {
  return axios.post("/api/feedback", params).then(res => res);
};
//获取谷歌地图经纬度
export const getMapLocation = params => {
  return axios.post("/api/get-map-location", params).then(res => res);
};
//删除我的收藏
export const deleteCollect = params => {
  return axios.post("/api/deleteCollect", params).then(res => res);
};

//添加征信记录
export const addCredit = params => {
  return axios.post("/api/creditreport/add", params).then(res => res);
};

//获取联系人详情
export const getContactDetail = params => {
  return axios.get("/api/get-contact-detail", { params: params });
};
//获取联系人详情
export const getVContactDetail = params => {
  return axios.get("/api/visitor/get-contact-detail", { params: params });
};
// 获取已有分组名
export const getHaveGroup = params => {
  return axios.get("/api/get-have-group", { params: params });
};
// 自定义添加分组名
export const addGroupName = params => {
  return axios.post("/api/add-group-name", params).then(res => res);
};
// 加入收藏
export const addToCollect = params => {
  return axios.post("/api/add-to-collect", params).then(res => res);
};
// 我的收藏数据列表
export const getLinkmanData = params => {
  return axios.post("/api/get-already-look-data", params).then(res => res);
};
// 修改分组名
export const modifyGroupName = params => {
  return axios.post("/api/modify-group-name", params).then(res => res);
};
// 删除分组
export const delGroup = params => {
  return axios.delete("/api/del-group", { params: params }).then(res => res);
};
// 按批量删除收藏数据
export const delCollects = params => {
  return axios.delete("/api/del-collect", { params: params }).then(res => res);
};
//收藏修改分组
export const addCollectGroup = params => {
  return axios.post("/api/add-collect-group", params).then(res => res);
};
// 收藏移出分组
export const removeGroup = params => {
  return axios.post("/api/remove-group", params).then(res => res);
};
// 游客搜征信公司（国内）
export const vGetCreditCompany = params => {
  return axios.get("/api/visitor/getCreditCompany", { params: params });
};
// 游客搜征信公司详情（国内）
export const vCreditCompanyDetail = params => {
  return axios.get("/api/visitor/creditCompanyDetail", { params: params });
};
// 用户搜征信公司（国内）
export const getCreditCompany = params => {
  return axios.get("/api/getCreditCompany", { params: params });
};
// 用户搜征信公司详情 （国内）
export const creditCompanyDetail = params => {
  return axios.get("/api/creditCompanyDetail", { params: params });
};
// 报告产品列表
export const productList = params => {
  return axios.get("/api/product-list", { params: params });
};
// 征信报告生成订单
export const createOrder = params => {
  return axios.post("/api/create-order", params).then(res => res);
};
// 订单支付
export const orderPay = params => {
  return axios.post("/api/pay/pay", params).then(res => res);
};
// 我的报告订单列表
export const orderList = params => {
  return axios.post('/api/order/order-lists', params).then(res => res)
}
// User - 获取订单信息
export const getPacketsOrder = params => {
  return axios.get('/api/getPacketsOrder', { params: params })
}
// 订单详情
export const orderDetail = params => {
  return axios.get('/api/order/detail', { params: params })
}
// 流量包详情
export const getPacketsOrderDetail = params => {
  return axios.get('/api/getPacketsOrderDetail', { params: params })
}
export const delPayOrder = params => {
  return axios.post('/api/delPayOrder', params).then(res => res)
}
// 我的报告下载
export const dowloadReport = params => {
  return axios.get("/api/order/dowload-report", { params: params });
};
// 判断企业是否有进出口记录
export const isImportExport = params => {
  return axios.get("/api/is-import-export", { params: params });
};
// 搜征信公司列表（国外
export const foreignCreditCompany = params => {
  return axios.get("/api/common/getCreditCompany", { params: params });
};
// 报告产品列表(搜不到或海外的)
export const productForNo = params => {
  return axios.get("/api/product-for-no", { params: params });
};
// 去支付
export const orderGoPay = params => {
  return axios.get("/api/order/order-go-pay", { params: params });
};
export const getCountryList = params => {
  return axios.get("/api/get-country-list", { params: params });
};
// 充值价钱获取
export const getRechargePrice = params => {
  return axios.get("/api/getRechargePrice", { params: params });
};

// 获取注册邮箱
export const regEmail = params => {
  return axios.get("/api/regEmail", { params: params });
};
// Member - vip价格获取
export const vipPrice = params => {
  return axios.get("/api/member/vip-price", { params: params });
};
// SaleChannel - 邀请码激活
export const activation = params => {
  return axios.post("/api/sale-channel/activation", params);
};

// 生成订单确认页(完成)
export const getOrderConfirm = params => {
  return axios.get('/api/order-confirm', { params: params })
}

//Common - 获取流量包信息
export const getPackets = params => {
  return axios.get('/api/getPackets', { params: params })
}
// 判断是否是渠道
export const checkIsDiscount = params => {
  return axios.get('/api/checkIsDiscount', { params: params })
}

// ip是否中国
export const ipCountry = params => {
  return axios.get("/api/ipCountry", { params: params });
};
// 社交账号相关

export const socialBind = params => {
  return axios.post("/api/social-bind", params);
};

// 汇率
export const getExchangeRate = params => {
  return axios.get("/api/getExchangeRate", { params: params });
};

// 用户D币过期获取
export const expired = params => {
	return axios.get('/api/dcurrency/expired', { params: params })
}
//  用户D币记录
export const dcurrencyList = params => {
	return axios.get('/api/dcurrency/list', { params: params })
}
//  D币兑换
export const dcurrencyExchange = params => {
	return axios.post('/api/dcurrency/exchange', params)
}
// 获取未读消息数量
export const unreadCount = params => {
	return axios.get('/api/member/unreadCount', { params: params })
}
// 获取流量包信息
export const getPacketsInfo = params => {
	return axios.get('/api/getPacketsInfo', { params: params })
}
// 获取热门国家
export const getHotCountryList = params => {
	return axios.get('/api/get-hot-country-list', { params: params })
}
// 友情链接列表
export const linksList = params => {
	return axios.get('/api/links/list', { params: params })
}


// 历史筛选条件
export const screeningConditionsList = params => {
	return axios.get('/api/searchScreeningConditions', { params: params })
}
export const recommendOption = params => {
	return axios.get('/api/recommend/option', { params: params })
}
// 社交图谱列表
export const socialGraphList = params => {
	return axios.post('/api/socialGraph/list', params)
}
// 社交图谱列表(游客)
export const vSocialGraphList = params => {
  return axios.post('/api/visitor/socialGraph/list', params)
}
// 社交图谱详情
export const socialGraphDetail = params => {
	return axios.get('/api/socialGraph/detail', { params: params })
}
// 社交图谱详情（游客）
export const vSocialGraphDetail = params => {
  return axios.get('/api/visitor/socialGraph/detail', { params: params })
}
//社交图谱公司相关公司
export const socialGraphRelation = params => {
	return axios.get('/api/socialGraph/relation', { params: params })
}
// 导出数据
export const exportData = params => {
	return axios.post('/api/export-data', params)
}
// 额度限制判断
export const lessenLimit = params => {
  return axios.get('/api/lessenLimit', { params: params })
}

// Defined
const link = url => `${url}`;
const get = url => params => axios.get(link(url), { params });
const post = url => params => axios.post(link(url), params);
const put = url => params => axios.put(link(url), params);
const del = url => params => axios.delete(link(url), { params });
//获取社交绑定链接
export const getSocialBindUrl = get("/api/social-bind");



// WEBPACK FOOTER //
// ./src/api/api.js